import { isTabletDevice } from '@axa-asia/hk-emma-web-module/lib/ga-lib/DeviceUtil';
import config from '../config';

/* eslint-disable no-console */
const previousScreenData = {
  preUrl: '',
  currentUrl: window.location.pathname,
  displayedButtonText: '',
};

function onLocationUrlChange(callback) {
  try {
    previousScreenData.currentUrl = window.location.pathname;
    if (typeof callback === 'function' && previousScreenData.preUrl !== previousScreenData.currentUrl) {
      callback(previousScreenData.preUrl, previousScreenData.currentUrl);
    }
    // updated preUrl to current url for next time url change
    previousScreenData.preUrl = previousScreenData.currentUrl;
  } catch (e) {
    console.error(e);
  }
}

export const setDisplayedButtonText = (displayedButtonText) => {
  previousScreenData.displayedButtonText = displayedButtonText;
};

export const getDisplayedButtonText = () =>
  previousScreenData.displayedButtonText;

export const getPreviousUrl = () => previousScreenData.preUrl;

export const getCurrentUrl = () => previousScreenData.currentUrl;

export const getPlatformStr = () => {
  if (config.isApp) {
    return 'APP';
  } 
  return 'WEB';
}


